import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=51a2efd1&scoped=true"
import script from "./unbind.vue?vue&type=script&lang=js"
export * from "./unbind.vue?vue&type=script&lang=js"
import style0 from "./unbind.vue?vue&type=style&index=0&id=51a2efd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2efd1",
  null
  
)

export default component.exports